import script from "./StarsIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./StarsIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__